import AppDispatcher from '../../../flux/dispatcher/dispatcher';
import Constant from '../constant/PaymentsConstant';
import restClient from '../../MainFrame/action/APIClient';
import LogoutConstant from '../../MainFrame/constants/Constants';

var DownloadInvoicePdfAction = function () {

}

DownloadInvoicePdfAction.prototype = {

	downloadInvoice: function (invoiceId) {
		restClient.downloadInvoice(invoiceId, function (error, response) {
			if (error) {
				// console.log("error", error);
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error
					});
				} else {
					AppDispatcher.dispatch({
						actionType: Constant.INVOICE_DOWNLOAD,
						data: error.responseText
					});
				}
			} else {
				AppDispatcher.dispatch({
					actionType: Constant.INVOICE_DOWNLOAD,
					data: response
				});
			}
		})
	}
}

export default new DownloadInvoicePdfAction();